import { Controller } from "@hotwired/stimulus"

// Attached to the character sheet's single <form>. The ONE owner of form-field
// access: other controllers OUTLET to it and ASK for a field's value/element
// (this.cp2020SheetOutlet.field("stat_ref")) instead of walking the DOM with
// closest("form"). Fields are named resource_form[<name>], so any input/select on
// the sheet is reachable by name here.
//
// Why an outlet, not closest("form"): it's an explicit, declared relationship (no
// dependence on DOM nesting), and it works IDENTICALLY on the edit form and the
// (non-submitting) read-only show sheet — a reader just declares the outlet; it
// never assumes a form ancestor exists. This controller reads only; it never
// submits.
export default class extends Controller {
  // The raw <input>/<select> element for a field name (or undefined). Callers that
  // need the element itself (e.g. to make it read-only) use this.
  fieldElement(name) {
    return this.element.elements?.[`resource_form[${name}]`]
  }

  // A field's string value ("" when absent/blank).
  field(name) {
    return this.fieldElement(name)?.value ?? ""
  }

  // A field parsed as an integer (0 when blank/NaN).
  intField(name) {
    const n = parseInt(this.field(name), 10)
    return Number.isNaN(n) ? 0 : n
  }
}
